/**
 * Service Worker killswitch
 *
 * 偵測舊版 SW（pre-9323276）在用戶瀏覽器留下的問題快取，
 * 自動 unregister + 清 caches + reload，讓用戶不用手動進 DevTools。
 *
 * 觸發條件：caches 裡找得到舊規則建立的 cache（static-resources / api-cache）。
 * 防迴圈：localStorage 記錄已套用的 KILL_VERSION，每個 version 只跑一次。
 *
 * 之後若需要再次強制清除（例如又有 SW 規則出包），bump KILL_VERSION 即可。
 */

const KILL_VERSION = 'v2-2026-05-10'
const STORAGE_KEY = 'sw-killswitch-applied'
const BAD_CACHE_PATTERNS = ['static-resources', 'api-cache']

export async function runSwKillswitch(): Promise<void> {
  if (typeof window === 'undefined') return
  if (!('serviceWorker' in navigator) || !('caches' in window)) return

  if (localStorage.getItem(STORAGE_KEY) === KILL_VERSION) return

  try {
    const cacheNames = await caches.keys()
    const hasBadCache = cacheNames.some(name =>
      BAD_CACHE_PATTERNS.some(pattern => name.includes(pattern))
    )

    if (!hasBadCache) {
      // 沒有舊 cache → 紀錄當前版本，避免下次又掃一遍
      localStorage.setItem(STORAGE_KEY, KILL_VERSION)
      return
    }

    console.warn('[swKillswitch] 偵測到舊 SW 殘留快取，執行清理…', cacheNames)

    const registrations = await navigator.serviceWorker.getRegistrations()
    await Promise.all([
      ...cacheNames.map(name => caches.delete(name)),
      ...registrations.map(reg => reg.unregister())
    ])

    localStorage.setItem(STORAGE_KEY, KILL_VERSION)

    // reload 拿乾淨環境（換上新 SW 與新 assets）
    location.reload()
  } catch (err) {
    console.error('[swKillswitch] 清理失敗：', err)
  }
}
